import type { FeatureShellPorts } from '@src/core/bootstrap/FeatureShellPorts.ts';
import {
  didShellBuildRevisionChange,
  readStoredShellBuildRevision,
  writeStoredShellBuildRevision,
} from '@src/modules/shared/local-sqlite/infrastructure/shellBuildRevisionGuard.ts';

export const OPEN_SYNC_UPDATE_TAB_SESSION_KEY = 'bono_open_sync_update_tab';

/** After shell mount: flag the Update tab when a new bundle revision was loaded. */
export function notifyPostShellBuildRevisionUpgrade(shellPorts: FeatureShellPorts): void {
  const previous = readStoredShellBuildRevision();
  const changed = didShellBuildRevisionChange(previous);

  if (changed) {
    try {
      globalThis.sessionStorage.setItem(OPEN_SYNC_UPDATE_TAB_SESSION_KEY, '1');
    } catch {
      /* sessionStorage unavailable */
    }
    shellPorts.notifications.info(
      'Nueva versión desplegada. Si la interfaz no se ve actualizada, abra Sync → pestaña Actualizar para limpiar la caché.',
    );
  }

  writeStoredShellBuildRevision();
}

/** Consumes the post-deploy flag (one shot per session). */
export function consumeOpenSyncUpdateTabFlag(): boolean {
  try {
    if (globalThis.sessionStorage.getItem(OPEN_SYNC_UPDATE_TAB_SESSION_KEY) === '1') {
      globalThis.sessionStorage.removeItem(OPEN_SYNC_UPDATE_TAB_SESSION_KEY);
      return true;
    }
  } catch {
    /* sessionStorage unavailable */
  }
  return false;
}
